import React, { useState } from 'react';
import Icon from '../Icon';
import Product from '../../Types/Product';
import {
  addProductToWishList,
  removeProductFromWishList,
  removeWishListItem,
  addWishListItem,
} from '../../Reducers/WishList.reducer';
import { useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';

const FavoriteButton = ({
  product,
  border = true,
}: {
  product: Product;
  border?: boolean;
}) => {
  const dispatch = useDispatch();
  const { wished } = product;
  const [isWished, setIsWished] = useState<boolean>(!!wished);
  const iconName = isWished ? 'heart-filled' : 'heart-empty';

  const wishlistClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!isWished) {
      dispatch(addProductToWishList(product));
      dispatch(addWishListItem({ product: product }));
    } else {
      dispatch(removeProductFromWishList(product));
      dispatch(removeWishListItem({ product: product }));
    }
    setIsWished((prev) => !prev);
  };

  return (
    <button
      className={`cursor-pointer ${
        border ? 'p-2 border-white rounded-full' : ''
      } hover:opacity-80 relative`}
      onClick={wishlistClick}
      aria-label={translate('wishlist.favoritebutton')}
      title={translate('wishlist.favoritebutton')}
    >
      <div className="w-6 h-6">
        <Icon
          name={iconName}
          className="w-full h-full"
          aria-label={translate('wishlist.favoriteicon')}
        />
      </div>
    </button>
  );
};
export default FavoriteButton;
